import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-select-item" }
const _hoisted_2 = { class: "p-select-item-label" }

import { computed } from 'vue';
interface Props {
	item: object | string | number,
	isIcon?: boolean|string,
	close?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'pSelectItem',
  props: {
    item: {},
    isIcon: { type: [Boolean, String] },
    close: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const name = computed(() => 
  typeof props.item === 'object' ? props.item.name : String(props.item)
);

const icon = computed(() => 
  typeof props.isIcon === 'string' ? props.isIcon : name
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.close)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "p-icon p-icon-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-click')))
        }))
      : _createCommentVNode("v-if", true),
    (_ctx.isIcon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(["p-icon", `p-icon-${icon.value}`]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('icon-click')))
        }, null, 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(name.value), 1 /* TEXT */)
  ]))
}
}

})